module.exports = __webpack_public_path__ + "img/-s-pic_product fkxt_cpjg.503f564f.svg";